import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import LoaderBar from '../../ui/LoaderBar'
import UrlParams from 'commons/js/util/UrlTo/UrlParams'
import { Box, Copy, Image } from '@elparking/components'
import { FormattedMessage } from 'react-intl'
import { useApi } from '@elparking/utils'
import reloadRentalCarSearch from 'commons/js/api/rentalCar/reloadRentalCarSearch'

const getParam = (param) => {
    const searchParams = new UrlParams()
    searchParams.loadFromUrl()
    return searchParams.get(param)
}

const StepPreBooking = ({
    requestUpdateBooking,
    token,
    onContinue,
    unbornId,
    error,
    reloadRentalCarSearch,
    id,
    uuid,
}) => {
    const {
        response: { result: mustReload, error: errorReload },
        loading,
        sendRequest: reloadUser,
    } = useApi(reloadRentalCarSearch)

    useEffect(() => {
        token && reloadUser({token, id, uuid})
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [reloadUser])

    useEffect(() => {
        token && !loading && !mustReload && requestUpdateBooking({token, id})
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loading, mustReload])
    useEffect(() => {
        unbornId && onContinue()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ unbornId ])
    if (errorReload || error) {
        return <Box mt='2em' p='1em 1em 4em 1em' textAlign='center'>
            <Image src='/images/rental-car/no-cards.svg' alt='Error' />
            <Copy padding='2em 0' fontColor='error' fontSize='large' fontWeight='medium' textAlign='center'>
                <FormattedMessage defaultMessage='No se ha podido cargar la reserva' />
            </Copy>
        </Box>
    }
    return (<LoaderBar />)
}

StepPreBooking.propTypes = {
    requestUpdateBooking: PropTypes.func,
    reloadRentalCarSearch: PropTypes.func,
    onContinue: PropTypes.func,
    token: PropTypes.any,
    unbornId: PropTypes.any,
    error: PropTypes.bool,
    uuid: PropTypes.any,
    id: PropTypes.any,
}

/* istanbul ignore next */
StepPreBooking.defaultProps = {
    id: getParam('unbornId'),
    uuid: getParam('uuid'),
    unbornId: null,
    token: null,
    error: false,
    onContinue: () => {},
    requestUpdateBooking: () => {},
    reloadRentalCarSearch,
}

export default StepPreBooking
